'use strict'

import * as types from './mutation-types'
import _ from 'lodash'

// Mutations
const mutations = (instance) => {
	return {
		// This mutation is intended to load all states which are stored in local
		[types.InitialiseStore] (state) {
			state.activeProject = instance.jnx.storageService.findItem('activeProject', true)
		},

		[types.ToggleNavBar] (state, payload) {
			state.navBarExpanded = payload.value
			return state.navBarExpanded
		},

		[types.UpdateCurrentUser] (state, payload) {
			state.currentUser = payload.value
			return state.currentUser
		},

		[types.UpdateEntryUrl] (state, payload) {
			state.entryUrl = payload.value
			return state.entryUrl
		},

		[types.UpdateActiveProject] (state, payload) {
			instance.jnx.storageService.setItem('activeProject', payload.value, true)
			state.activeProject = payload.value
			return state.activeProject
		},

		[types.UpdateLastOrder] (state, payload) {
			instance.jnx.storageService.setItem('lastOrder', payload.value, true)
			state.lastOrder = payload.value
			return state.lastOrder
		},

		[types.ChangeCheckoutActiveTab] (state, payload) {
			state.checkoutActiveTab = payload.value
			return state.checkoutActiveTab
		},

		[types.LoadProductList] (state, payload) {
			state.productsList = payload.value
			return state.productsList
		},

		[types.AddToCart] (state, product) {
			// const record = state.added.find(p => p.sku === sku)
			const record = _.find(state.addedProducts, {sku: product.sku})
			console.log('added to cart, sku:', product.sku)

			if (_.isNil(record)) {
				let toAdd = _.clone(product)
				delete toAdd.checked
				toAdd.quantity = (toAdd.quantity) ? toAdd.quantity : 1
				state.addedProducts.push(toAdd)
			} else {
				record.quantity++
			}
			return state.addedProducts
		},

		[types.ClearCart] (state) {
			state.addedProducts = []
			return state.addedProducts
		},

		[types.InfoDialog] (state, text) {
			state.dialog.info = {
				text, show: !state.dialog.info.show
			}
			return state.dialog.info
		}

		// setLang (state, payload) {
		// 	app.$i18n.locale = payload
		// }
	}
}

export default mutations



// WEBPACK FOOTER //
// ./src/common/store/mutations.js